export default function loadLocale(locale) {
      return locale==='en'||
locale==='en-US'? import(/* webpackChunkName: "en-US" */'./en-US'):
locale==='en-GB'? import(/* webpackChunkName: "en-GB" */'./en-GB'):
locale==='en-AU'? import(/* webpackChunkName: "en-AU" */'./en-AU'):locale==='fr'||
locale==='fr-FR'? import(/* webpackChunkName: "fr-FR" */'./fr-FR'):
locale==='fr-CA'? import(/* webpackChunkName: "fr-CA" */'./fr-CA'):locale==='de'||
locale==='de-DE'? import(/* webpackChunkName: "de-DE" */'./de-DE'):locale==='it'||
locale==='it-IT'? import(/* webpackChunkName: "it-IT" */'./it-IT'):locale==='es'||
locale==='es-419'? import(/* webpackChunkName: "es-419" */'./es-419'):
locale==='es-ES'? import(/* webpackChunkName: "es-ES" */'./es-ES'):locale==='ja'||
locale==='ja-JP'? import(/* webpackChunkName: "ja-JP" */'./ja-JP'):locale==='pt'||
locale==='pt-PT'? import(/* webpackChunkName: "pt-PT" */'./pt-PT'):
locale==='pt-BR'? import(/* webpackChunkName: "pt-BR" */'./pt-BR'):locale==='zh'||
locale==='zh-CN'? import(/* webpackChunkName: "zh-CN" */'./zh-CN'):
locale==='zh-TW'? import(/* webpackChunkName: "zh-TW" */'./zh-TW'):
locale==='zh-HK'? import(/* webpackChunkName: "zh-HK" */'./zh-HK'):locale==='nl'||
locale==='nl-NL'? import(/* webpackChunkName: "nl-NL" */'./nl-NL'):locale==='ko'||
locale==='ko-KR'? import(/* webpackChunkName: "ko-KR" */'./ko-KR'):locale==='fi'||
locale==='fi-FI'? import(/* webpackChunkName: "fi-FI" */'./fi-FI'):null;
}
